import { render, staticRenderFns } from "./ModalMediaGallery.vue?vue&type=template&id=571d12a8&scoped=true"
import script from "./ModalMediaGallery.vue?vue&type=script&lang=js"
export * from "./ModalMediaGallery.vue?vue&type=script&lang=js"
import style0 from "./ModalMediaGallery.vue?vue&type=style&index=0&id=571d12a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "571d12a8",
  null
  
)

export default component.exports